import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTable } from '@angular/material/table';
import { Message, MessagesResponse, MsgsService, Template } from 'generated-sources/openapi';
import { Observable } from 'rxjs';
import { MessageTableDataSource } from './message-table-datasource';

@Component({
  selector: 'app-message-table',
  templateUrl: './message-table.component.html',
  styleUrls: ['./message-table.component.css']
})
export class MessageTableComponent implements AfterViewInit, OnInit, OnChanges {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<Message>;
  @Input() data: Observable<MessagesResponse>;
  @Input() templates: Template[];
  @Input() index = 0;
  @Input() pageSize = 50;
  @Output() onPageChange = new EventEmitter<PageEvent>();
  @Output() onSortChange = new EventEmitter<Sort>();
  dataSource: MessageTableDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['name', 'template', 'phone', 'sent_by', 'updated', 'status'];

  ngOnInit() {
    this.dataSource = new MessageTableDataSource(this.data);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // this.dataSource?.update(this.data);
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.table.dataSource = this.dataSource;
    this.sort.sortChange.subscribe(evt => { this.onSortChange.emit(evt) });
  }

  getTemplateName(id: number) {
    const tmp = this.templates?.find(el => el.id === id);
    return tmp?.name;
  }
}
